const COLOR_RED = '#ef4141';
const COLOR_LIGHT_GREY = '#d8d8d8';
const COLOR_LIGHTEST_GREY = '#979797';
const COLOR_WHITE = '#fff';

export default {
    COLOR_RED,
    COLOR_LIGHT_GREY,
    COLOR_LIGHTEST_GREY,
    COLOR_WHITE,
};
